import { t } from 'i18next';
import { Dispatch, SetStateAction } from 'react';

const notificationOptinsEnum = ['edit', 'duplicate', 'delete'];

export const handleMenuItemClick = (value: string) => {
  switch (value) {
    case 'edit':
      console.log('edit');
      break;
    case 'duplicate':
      console.log('duplicate');
      break;
    case 'delete':
      console.log('delete');
      break;
    default:
      break;
  }
};

export const notificationOptions = (setOpen: Dispatch<SetStateAction<boolean>>) =>
  notificationOptinsEnum.map((option) => ({
    label: t(`components:notifications.form.buttons.${option}`),
    onClick: () => {
      handleMenuItemClick(option);
      setOpen(false);
    },
  }));
